/*
 * @Author: your name
 * @Date: 2021-06-03 09:24:51
 * @LastEditTime: 2021-09-15 14:10:14
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \admin\src\plugins\language\zh.js
 */
module.exports = {
    Public: {
        chainError: '链路连接有误，请检查后重新链接',
        chainChange: '请在metamask上手动切换',
        openError: '剩余可抽取數量不足，抽取失敗',
        more: '查看更多',
        buy: '立即購買',
        editions: '發售版數',
        day: '天',
        hour: '小時',
        min: '分鐘',
        paySuccess: '購買成功'
    },
    Head: {
        menu: '菜單',
        connect: '連接錢包',
        close: '關閉'
    },
    Footer: {
        slogan: '建立在區塊鏈技術上的藝術品與潮玩發行平臺',
        contact: '聯絡我們',
        about: '關於',
        userAbout: '用戶協議',
        privacyAbout: '隱私政策'
    },
    Menu: {
        home: '主頁',
        drops: '藝術盲盒',
        news: '新聞資訊',
        bazaar: '集市',
        discover: '藝術發現',
    },
    Index: {
        artBlindBox: '藝術盲盒',
        artFragments: '藝術碎片',
        subFragments: '顛覆傳統藝術市場，讓藝術不再神秘',
        fragment1: '一件藝術品“分割”為N份碎片',
        fragment2: '每個碎片與唯一的NFT綁定',
        fragment3: '每個藝術品包含了獨特的背景故事',
        fragment4: '集齊藝術碎片，可以拼接成完整的藝術品NFT ',
        fragment5: '搭建傳統藝術世界與鏈上世界的橋梁',
        token: 'Non-Fungible Token',
        subToken: '基於區塊鏈NFT技術打造唯一的數字化藝術品',
        t1: '強流通',
        t2: '可追溯',
        t3: '鑒真僞',
        t4: '唯一性',
        t5: '數字化',
        t6: '防篡改',
        subT1: '基於數字流通場景打造便捷性作品交易網絡',
        subT2: '利用區塊時間戳記錄作品創作流通中的每個環節',
        subT3: '每一件作品在鏈上可識別查看區塊信息',
        subT4: '基於ERC-721協議等保證作品獨一無二',
        subT5: '藝術品數字化上鏈存儲 加密憑證確權',
        subT6: '加密技術保護 防止信息篡改',
        about: '關於我們',
        about1: 'M Space是基於區塊鏈的 NFT 藝術品與潮玩資產發行平臺。專註於 NFT 藝術資產發行，針對當下的藝術市場和潮流文化市場，主打藝術碎片與盲盒玩法，旨在引入DAO治理方案打造藝術粉絲的自治社區，為藝術和時尚賦能。',
        about2: '目前我們已與全球重量級藝術家、畫廊、拍賣行合作，持續在平臺上推出加密藝術品，實現實體與數字藝術的結合。簽約合作的國際知名數字藝術家包括但不限於：NFN Kalyan，Chad Knight，Peter Mohrbach，Macomoroni，田曉磊等，這些國際頂尖的數字藝術家對社交媒體和NFT世界都有著巨大的影響。',
    },
    Market: {
        title: '集市',
        screen: {
            price: '價格',
            popular: '知名度',
            onSale: '在售作品',
            sellOut: '售罄作品',
        },
        search: '搜索作品',
        pay: '數量',
        confirm: '確認',
        edition: '發售版數',
        number: '數量',
        payment: '支付方式',
        remaining: '剩余{number}個',
        tips: '是否支付購買費用',
        success: '付款成功 該作品已經發放到作品賬戶'
    },
    drops: {
        preEndTime: '距開始還剩',
        endTime: '距結束還剩',
        draw: {
            title: '優惠規則',
            rules: [
                '在第三個盲盒系列推出前（4月13日前），在M Space的錢包地址中累計消費金額≥3000USDT的地址，可享受以下優惠:',
                '1. 獲得1次免費抽獎的機會（僅限長期盲盒）；',
                '2. 選擇“10連抽”可享受9折優惠（只適用於長期盲盒）。',
                '第三個盲盒系列推出後（4月13日以後），累計充值金額≥3000USDT的登錄地址，可享受以下優惠:',
                '選擇“10連抽”可享受9折優惠（只適用於長期盲盒）。'
            ]
        }
    },
    author: {
        works: '藝術作品',
        profile: '藝術家簡介',
    },
    user: {
        gender: '性别',
        age: '年齡',
        edit: '編輯個人資料',
        logout: '登出賬戶',
        setName: '設置昵稱，最多6個字符',
        setGender: '性別',
        setBirthday: '出生日期',
        setProfile: '設置你的個人簡介，最多30個字符',
        setEmail: '請填寫你的郵箱地址',
        save: '保存',
        male: '男',
        female: '女',
        ownedQuantily: '擁有數量',
        mintedTime: '鑄造時間',
        createTime: '上架時間'
    }
}


// WEBPACK FOOTER //
// ./src/plugins/language/zh.js